import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const WorkScheduleList = Loadable(lazy(() => import("./WorkScheduleList")));
const WorkScheduleForm = Loadable(lazy(() => import("./WorkScheduleForm")));

const workScheduleRoutes = [
  {
    path: "/WorkSchedule/WorkScheduleList",
    element: <WorkScheduleList />,
    permission: PERMISSIONS.WorkSchedules.Menu,
  },
  {
    path: "/WorkSchedule/WorkScheduleForm",
    element: <WorkScheduleForm />,
  },
  {
    path: "/WorkSchedule/WorkScheduleForm/:id",
    element: <WorkScheduleForm />,
  },
];
export default workScheduleRoutes;
